import isFinite from 'lodash/isFinite';
import {View} from 'react-native';
import moment from 'moment';
import sy from '~/styles';
import {Text, Link, Dialog, WarrantyIcon} from '~/components/controls';
import {Row as GroupingRow} from '~/components/controls/Grouping';
import Format from '~/lib/format';
export const ActivityRow = ({disabled, rob_code, description, onPress}) => (
  <GroupingRow
    style={[sy['gap-2']]}
    contentStyle={[sy['flex-1']]}
    title={<Text style={sy.mediumPlus}>Activiteit</Text>}>
    <Link
      disabled={disabled}
      textStyle={[sy.truncate, sy['text-right']]}
      onPress={onPress}>
      {rob_code ? (
        <>
          {rob_code}&nbsp;&middot;&nbsp;
          {description}
        </>
      ) : (
        <>Keuze maken</>
      )}
    </Link>
  </GroupingRow>
);
export const HistoryAge = ({part, mileage}) =>
  isFinite(part.mileage) && isFinite(mileage) ? (
    <View style={sy['items-end']}>
      <Text>{Format.number(mileage - part.mileage, 0, true)}&nbsp; km</Text>
      <Text style={[sy.small, sy['text-lightgray']]}>
        {Format.number(
          moment().diff(moment(part.date), 'months') / 12,
          1,
          true,
          {
            minimumFractionDigits: 0,
          },
        )}
        &nbsp;jaar
      </Text>
    </View>
  ) : (
    <Text>
      {Format.number(moment().diff(moment(part.date), 'months') / 12, 1, true, {
        minimumFractionDigits: 0,
      })}
      &nbsp;jaar
    </Text>
  );

export const WarrantyInfoDialog = ({title, onDismiss}) => (
  <Dialog
    visible={true}
    title={title}
    onDismiss={onDismiss}
    buttons={[
      {
        text: 'OK',
        onPress: onDismiss,
      },
    ]}
    options={{noPaddingContent: true}}>
    <View style={[sy['flex-row'], sy['gap-4'], sy['p-4']]}>
      <View style={[sy['shrink-0']]}>
        <WarrantyIcon value={{warranty: 'Warranty'}} width="24" height="24" />
      </View>
      <Text>
        Garantie toegepast. Bedrag voor activiteit aangepast naar 0,00 euro.
      </Text>
    </View>
  </Dialog>
);
